import DesktopCarousel from '../Components/Home/DesktopCarousel';
import MobileCards from '../Components/Home/MobileCards';
import { Row, Col, Container, Nav, Dropdown, Carousel } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import MakeRequest from '../Components/Helpers/MakeRequest';
import GoogleMaps from "../Components/GoogleMaps.jsx";


const Icon = {
  map: (
    <svg width="1em" height="1em" viewBox="0 0 24 24" className="me-2">
      <path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5Z" />
    </svg>
  ),
  mail: (
    <svg width="1em" height="1em" viewBox="0 0 24 24" className="me-2">
      <path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4l-8 5L4 8V6l8 5l8-5v2Z" />
    </svg>
  ),
  phone: (
    <svg width="1em" height="1em" viewBox="0 0 24 24" className="me-2">
      <path fill="currentColor" d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.25c1.11.37 2.3.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C11.85 21 3 12.15 3 2a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.28.2 2.47.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2Z" />
    </svg>
  ),
};

const toLines = (value) =>
  Array.isArray(value)
    ? value.filter(Boolean)
    : String(value || "")
      .split(/\r?\n|,|;/)
      .map((s) => s.trim())
      .filter(Boolean);

const toTelHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;
const toMailHref = (email) => `mailto:${email}`;
const toMapsHref = (addr) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}`;

const Section = ({ heading, icon, children }) => (
  <section className="mb-4">
    <h2 className="h5 d-flex align-items-center mb-3">
      <span className="d-inline-flex align-items-center justify-content-end rounded-circle bg-light border me-2" style={{ width: 36, height: 36 }}>
        {icon}
      </span>
      {heading}
    </h2>
    {children}
  </section>
);

const ItemCard = ({ title, subtitle, rightAction }) => (
  <div className="border rounded-3 p-3 mb-3 shadow-sm">
    <div className="d-flex justify-content-between align-items-start">
      <div>
        {title && <div className="fw-semibold">{title}</div>}
        {subtitle}
      </div>
      {rightAction}
    </div>
  </div>
);

const Contact = () => {
  const { l } = useOutletContext();

  const [contactInfo, setContactInfo] = useState({});
  const [mapsApi, setMapsApi] = useState(null);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await MakeRequest(null, 'content/pageContent?page=contact', 'get');
        setContactInfo(response.data[0]);
      } catch (error) {
        console.error('Error fetching retailers:', error);
      }
    };
    fetchContactInfo();
  }, []);

  useEffect(() => {
    const fetchAdresses = async () => {
      const response = await MakeRequest(null, `geocode?type=contact`, 'get');
      const addressInfo = response.data?.map(geo => {
        const { titleSwe, titleEng } = geo;
        return {
          googledata: geo,
          title: l(titleSwe, titleEng)
        }
      });
      setMapsApi(addressInfo)
    };
    if (contactInfo.addresses) {
      fetchAdresses()
    };
  }, [contactInfo]);
  
  return (
    <Container className="my-lg-5 my-3">
      <Row className="gy-4">
        <Col md={6} lg={7}>
          {/*           <h1 className="mb-4">{l("Kontakt", "Contact")}</h1>
          {contactInfo?.content && (
            <p className="mb-4">{l(contactInfo.content?.sv, contactInfo.content?.en)}</p>
          )} */}
          <div className="mb-5">
            <h1 className="mb-3 fw-bold">
              {l("Kontakt", "Contact")}
            </h1>
            <p className="text-muted lead mb-0">
              {l(contactInfo.content?.sv, contactInfo.content?.en)}
            </p>
          </div>

          {/* Addresses */}
          {contactInfo?.addresses?.length > 0 && (
            <Section heading={l("Adresser", "Addresses")} icon={Icon.map}>
              {contactInfo.addresses.map(({ titleSwe, titleEng, content }, idx) => {
                const lines = toLines(content);
                const full = lines.join(", ");
                return (
                  <ItemCard
                    key={`addr-${idx}`}
                    title={l(titleSwe, titleEng)}
                    subtitle={
                      <address className="mb-0">
                        {lines.map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                      </address>
                    }
                    rightAction={
                      full ? (
                        <a
                          className="btn btn-outline-primary btn-sm ms-3"
                          href={toMapsHref(full)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={l("Öppna i Kartor", "Open in Maps")}
                        >
                          {l("Öppna i Kartor", "Open in Maps")}
                        </a>
                      ) : null
                    }
                  />
                );
              })}
            </Section>
          )}

          {/* Emails */}
          {contactInfo?.emails?.length > 0 && (
            <Section heading={l("E-post", "Email")} icon={Icon.mail}>
              {contactInfo.emails.map(({ titleSwe, titleEng, content }, idx) => {
                const emails = toLines(content);
                return (
                  <ItemCard
                    key={`mail-${idx}`}
                    title={l(titleSwe, titleEng)}
                    subtitle={
                      <ul className="list-unstyled mb-0">
                        {emails.map((email, i) => (
                          <li key={i}>
                            <a href={toMailHref(email)} className="link-primary">{email}</a>
                          </li>
                        ))}
                      </ul>
                    }
                  />
                );
              })}
            </Section>
          )}

          {/* Phones */}
          {contactInfo?.phones?.length > 0 && (
            <Section heading={l("Telefon", "Phone")} icon={Icon.phone}>
              {contactInfo.phones.map(({ titleSwe, titleEng, content }, idx) => {
                const phones = toLines(content);
                return (
                  <ItemCard
                    key={`phone-${idx}`}
                    title={l(titleSwe, titleEng)}
                    subtitle={
                      <ul className="list-unstyled mb-0">
                        {phones.map((ph, i) => (
                          <li key={i}>
                            <a href={toTelHref(ph)} className="link-primary">{ph}</a>
                          </li>
                        ))}
                      </ul>
                    }
                  />
                );
              })}
            </Section>
          )}
        </Col>

        {/* <Col md={6} lg={5}>
          <div className="rounded-3 overflow-hidden border shadow-sm">
            <GoogleMaps mapsApi={mapsApi} apiKey={process.env.GOOGLE_API_KEY} l={l} type={"contact"}/>
          </div>
        </Col> */}
      </Row>
    </Container>
  );
}

export default Contact;